<template>
	<section>
		<b-row :class="['bg-white', specialClass]">
			<b-col>
				<slot></slot>
			</b-col>
		</b-row>
	</section>
</template>

<script>
  export default {
	name: 'v-section-white',
	props: {
		specialClass: String
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>